import pouchdb from "./pouchdb";
import { getNewId, isEmpty } from "./utils";


export interface ResultDb<dataProps> {
    status: "ok" | "error" | "not_found",
    msg?: string,
    row?: dataProps | any
    rows?: dataProps[] | any[]
}

interface Error {
    error: string,
    id: string,
    message: string;
    name: string;
    reason: string;
    status: number;
}
interface FieldsFilterParams {
    fieldName: string,
    fieldValue: any,
    mangoQuery: '$eq' | '$gt' | '$gte' | '$lt' | '$lte' | '$in' | '$regex' | '$elemMatch' | '$ne' | '$and' | ''
}
export interface FilterParamsInterface {
    fieldsFilter: Array<FieldsFilterParams>;
    indexName: string;
    sortBy?: string[];
    limit?: number;
}

export interface FilterViewParams {
    viewName: string,
    resultViewFull: boolean,
    opt: PouchDB.Query.Options<{}, {}>
}

export interface PrmsSync {
    functionCallbackChange: (prms: PouchDB.Replication.SyncResult<{}>) => void;
    handleCallbackPause: (prmState: any) => void;
    handleErrorCallback: (error: any) => void;
    handleFirstReplicateDone: (info: any) => void;
    dataAmericana: string;
}

interface LoginDbProps {
    login: string
    pass: string
    db: string
}

type StatusConnexao = "on" | "off"
type dbConnected = "local" | "remote"


const statusApp = process.env.PARCEL_STATUS_APP ?? "DEV";
const urlRemote = statusApp === "DEV" ? process.env.PARCEL_BASE_URL_DEV ?? "" : process.env.PARCEL_BASE_URL_PROD ?? "";
    

class Db<dataProps> {
    private dbRemote: PouchDB.Database;
    private dbLocal: PouchDB.Database;
    public statusConexao: StatusConnexao = "off";
    public sync: PouchDB.Replication.Sync<{}> = {} as PouchDB.Replication.Sync<{}>;
    public dbConnected: dbConnected = "local";

    constructor() {
        this.dbRemote = {} as PouchDB.Database;
        this.dbLocal = {} as PouchDB.Database;
    }

    connected = async (): Promise<{ status: "ok" | "error", msg: string }> => {
        try {
            const info = await this.dbRemote.info();
            console.log("info db online", info);
            this.setStatusConnexao("on")
            return info.db_name !== undefined ? { status: "ok", msg: "Conectado com sucesso!" } : { status: "error", msg: "Não conectado" };
        }
        catch (error: any) {
            console.log("error connected", error);
            this.setStatusConnexao("off")
            return { status: "error", msg: error.message };
        }
    }

    connect = (props: LoginDbProps) => {
        try {
            this.dbRemote = new pouchdb(
                urlRemote + props.db,
                {
                    auth: { username: props.login, password: props.pass },
                });
            this.dbLocal = new pouchdb(
                props.db,
                {
                    auth: { username: props.login, password: props.pass },
                });
        } catch (error) {
            console.log("error connect db", error);
        }
    }
    setStatusConnexao = (status: StatusConnexao) => {
        this.statusConexao = status;
    }

    setDbConnected = (dbConnected: dbConnected) => {
        this.dbConnected = dbConnected;
    }

    getDocID = async (doc_id: string): Promise<ResultDb<dataProps>> => {
        try {
            let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
            console.log("chamou getDocID", doc_id);
            const data = await DB_USE.get(doc_id, { conflicts: true, attachments: true, binary: true });
            return { status: 'ok', row: data as dataProps, msg: "Registro localizado com sucesso!" };
        } catch (error) {
            console.log("error getDocID", error)
            return { status: 'error', msg: 'Falha na busca do doc.' + JSON.stringify(error) };
        }
    }

    getAllDocsLocal = async (): Promise<ResultDb<dataProps>> => {
        try {
            let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
            let result = await DB_USE.allDocs({ include_docs: true, descending: true, });
            console.log("getAllDocsLocal result", result);
            let rows: dataProps[] = [];
            result.rows.map(row => {
                rows.push(row.doc as dataProps);
            })
            return { status: 'ok', rows: rows, msg: "Registros localizados com sucesso!" }
        } catch (error) {
            return { status: 'error', msg: 'Ocorreu uma falha ao buscar os dados locais.' + error }
        }
    }

    upsertData = (doc_id: string, data: any) => {
        data.upsert = data.upsert || 0;
        data.upsert++;
        let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
        return DB_USE.upsert(doc_id, (doc) => { doc = data; return doc }).then((resp) => {
            return { status: 'ok', row: resp, msg: "Registro com conflito, corrigido com sucesso!" };
        })
            .catch((err) => {
                return { status: 'error', msg: err, row: {} as any };
            })
    }

    createData = async (data: any) => {
        /* @createData
        * cria novo documento local
        */
        let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
        return DB_USE.post(data).then((response) => {
            return { status: 'ok', row: response, msg: "Registro criado com sucesso!" };
        }).catch((err) => {
            console.log("error createData", err)
            if (err.name === 'conflict') {
                return this.upsertData(data._id, data);
            } else {
                return { status: 'error', msg: err, row: {} as any };
            }
        });
    }

    updateData = async (data: any) => {
        let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
        return DB_USE.put(data).then((response) => {
            return { status: 'ok', row: response, msg: "Registro atualizado com sucesso!" }
        }).catch((err: any) => {
            console.log("error updateData", err)
            if (err.name === 'conflict') {
                return this.upsertData(data._id, data);
            } else {
                return { status: 'error', msg: err, row: {} as any };
            }
        });
    }

    deleteData = async (data: any) => {
        let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
        data._deleted = true;
        return DB_USE.put(data).then((response) => {
            return { status: 'ok', row: response, msg: "Regsitro removido com sucesso!" }
        }).catch((err) => {
            if (err.name === 'conflict') {
                return this.upsertData(data._id, data);
            } else {
                return { status: 'error', msg: err, row: {} as any };
            }
        });
    }

    salvar = async (row: any): Promise<ResultDb<dataProps>> => {
        console.log("chamou salvar", row);
        const detalharError = (error: any) => {
            let detalhes: Error = {
                error: error['error'],
                id: error['id'],
                message: error['message'],
                name: error['name'],
                reason: error['reason'],
                status: error['status'],
            }
            return detalhes;
        }
        if (row._rev) {
            //Update
            try {
                row.modified_at = new Date().toISOString();
                const result = await this.updateData(row);
                console.log("salva updade result", result)
                if (result.status === 'ok') {
                    row._rev = result.row.rev;
                    return { status: 'ok', row: row, msg: result.msg };
                } else {
                    let error = detalharError({ message: "Ocorreu um falha e os dados não foram salvos. Detalhes: " + JSON.stringify(result) })
                    return { status: 'error', msg: error.message }
                }
            } catch (erro) {
                let error = detalharError(erro)
                return { status: 'error', msg: error.message };
            }
        } else {
            //new
            try {
                if (isEmpty(row.created_at))
                    row.created_at = new Date().toISOString();
                const result = await this.createData(row);
                if (result.status === 'ok') {
                    row._id = result.row.id;
                    row._rev = result.row.rev;
                    return { status: 'ok', row: row, msg: result.msg };
                } else {
                    let error = detalharError({ message: "Ocorreu um falha e os dados não foram salvos. Detalhes: " + JSON.stringify(result) })
                    return { status: 'error', msg: error.message }
                }
            } catch (erro) {
                let error = detalharError(JSON.stringify(erro))
                return { status: 'error', msg: error.message };
            }
        }
    };

    salveAll = async (docs: any[]): Promise<ResultDb<dataProps>> => {
        try {
            let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
            const resp = await DB_USE.bulkDocs(docs);
            let rows: dataProps[] = [];
            resp.map(respRow => {
                let doc = docs.find(doc => doc._id === respRow.id);
                doc._rev = respRow.rev;
                rows.push(doc);
            });
            return { status: "ok", rows: rows as dataProps[] };
        } catch (error: any) {
            return { status: 'error', msg: error };
        }
    }

    public filterDeep = async (selector:any, index:{fields: string[], name: string}): Promise<ResultDb<dataProps>> => {
        try {
            let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
            let indexOpt: PouchDB.Find.CreateIndexOptions = {
                index: index
            }
            let respCreateIndex = await DB_USE.createIndex(indexOpt)
            console.log("resp create index", respCreateIndex);
            if (respCreateIndex.result) {
                let find: any = {};
                find['selector'] = selector
                find['limit'] = 1000
                console.log("opt find com index", find)
                let respFind = await DB_USE.find(find);
                console.log("resp Find", respFind);
                return { status: 'ok', rows: respFind.docs };
            } else {
                console.log("Erro ao criar o index", respCreateIndex)
                return { status: 'error', msg: 'Erro ao criar o index. Detalhes ' + respCreateIndex };
            }
        } catch (error) {
            console.log("error filterDeep", error);
            return { status: 'error', msg: 'Falha geral na estrutura da função filterDeep em Db. Detalhes ' + JSON.stringify(error) };
        }
    }

    public filter = async (prm: FilterParamsInterface): Promise<ResultDb<dataProps>> => {
        //montar estrutura index e selector
        try {
            console.log("prm filter", prm);
            var fields = Array<string>()
            var selector: any = {};
            var find: any = {};
            var indexOpt: PouchDB.Find.CreateIndexOptions
            let DB_USE: PouchDB.Database<{}>;
            prm.fieldsFilter.map(value => {
                if (value) {
                    fields.push(value.fieldName);
                    if (value.mangoQuery !== '') {
                        selector = {
                            ...selector,
                            [value.fieldName]: {
                                [value.mangoQuery]: Array.isArray(value.fieldValue) ? value.fieldValue.valueOf() : value.fieldValue
                            }
                        }
                    } else {
                        selector = {
                            ...selector,
                            [value.fieldName]: Array.isArray(value.fieldValue) ? value.fieldValue.valueOf() : value.fieldValue
                        }

                    }
                }
            })

            if (this.dbConnected === "remote") {
                DB_USE = this.dbRemote;
                find['selector'] = selector
                find['limit'] = 1000
                indexOpt = {
                    index: {
                        fields: fields,
                        name: prm.indexName,
                    }
                }
            } else {
                DB_USE = this.dbLocal;
                find['selector'] = selector
                find['use_index'] = prm.indexName
                find['limit'] = 1000
                indexOpt = {
                    index: {
                        fields: fields,
                        ddoc: prm.indexName,
                    }
                }
            }

            console.log("db use filter", DB_USE);
            let respCreateIndex = await DB_USE.createIndex(indexOpt)
            console.log("resp create index", respCreateIndex);
            if (respCreateIndex.result) {
                console.log("opt find com index", find)
                //console.log("start filter find"+new Date().toISOString())
                let respFind = await DB_USE.find(find);
                //console.log("end filter find"+new Date().toISOString())
                console.log("resp Find", respFind);
                return { status: 'ok', rows: respFind.docs };
            } else {
                console.log("Erro ao criar o index", respCreateIndex)
                return { status: 'error', msg: 'Erro ao criar o index. Detalhes ' + respCreateIndex };
            }

        } catch (error) {
            console.log("error filter", error);
            return { status: 'error', msg: 'Falha geral na estrutura da função filter em Db. Detalhes ' + JSON.stringify(error) };
        }
    }

    public filterView = async (prm: FilterViewParams): Promise<ResultDb<dataProps>> => {
        try {
            let DB_USE = this.dbConnected === "remote" ? this.dbRemote : this.dbLocal;
            const { opt, resultViewFull, viewName } = prm
            console.log("opt em filterView", opt);
            let resp = await DB_USE.query(viewName, opt);
            console.log("resp filterView", resp);
            let rows: any[] = [];
            if (!resultViewFull) {
                resp.rows?.map(row => {
                    if (opt.include_docs)
                        rows.push(row.doc);
                    else
                        rows.push(row.value);
                });
            } else {
                rows = resp.rows!;
            }
            return { status: "ok", rows: rows }
        } catch (error: any) {
            console.log("Error filterView", error);
            return { status: 'error', msg: 'Falha geral na estrutura da função filterView em Db. Detalhes ' + error };
        }

    }

    public dbReplicado = () => {
        //teste se o db ja foi iniciado alguma vez
        let lastReplicatedAt = localStorage.getItem("last_replicated_at_" + this.dbLocal.name);
        if (lastReplicatedAt !== null)
            return true
        return false
    }

    public replicadoHoje = () => {
        //verificar se ja fez alguma replicacao no dia atual
        let lastReplicatedAt = localStorage.getItem("last_replicated_at_" + this.dbLocal.name);
        let hoje = new Date().toISOString().substring(0, 10);
        if (lastReplicatedAt === hoje)
            return true
        return false
    }

    public replicar = async (dataRep: string): Promise<{ status: 'ok' | 'error', data?: any, mensagem?: any }> => {
        try {
            console.log("chamou replicar", dataRep)
            //verificar se ja fez alguma replicacao no dia atual
            let replicadoHoje = this.replicadoHoje();
            if (replicadoHoje) {
                //esse e um procedimento para que a inicializacao do app seja mais rapida,
                console.log("ja replicou hoje, ignorando replicacao");
                return { status: "ok", mensagem: "Já foi replicado hoje." };
            }
            let resp = this.dbLocal.replicate.from(this.dbRemote, {})
                .on("complete", (info) => {
                    console.log("replicar complete", info)
                    let hoje = new Date().toISOString().substring(0, 10);
                    localStorage.setItem("last_replicated_at_" + this.dbLocal.name, hoje);
                    this.setStatusConnexao("on");
                    return { status: "ok" }
                })
                .on("change", (info) => {
                    console.log("replicar change", info)
                })
                .on("denied", (info) => {
                    console.log("replicar denied", info)
                })
                .on("error", (err) => {
                    this.setStatusConnexao("off")
                    return { status: "error", mensagem: err }
                })
            const value = await resp;
            if (value.ok) {
                return { status: "ok" };
            } else {
                //se ouve algum erro, mas ja foi replicado algum dia, retornar ok
                if (replicadoHoje) {
                    return { status: "ok", mensagem: "Já foi replicado anteriormente." };
                }
                return { status: "error", mensagem: value.errors };
            }

        } catch (error) {
            console.log("error ao replicar", error)
            return { status: "error", mensagem: error }
        }
    }

    public startSync = (prms: PrmsSync) => {
        console.log("chamou startSync", prms)
        let dtSync = prms.dataAmericana;
        //let filterSync = "func/replicate_doc_app_scambPDV";
        this.sync = this.dbLocal.sync(this.dbRemote, {
            live: true,
            retry: false,
        })
            .on("change", (change) => { prms.functionCallbackChange(change); console.log("change sync", prms) })
            .on("paused", (msg) => { prms.handleCallbackPause(msg); console.log("pause loading data", msg) })
            .on("error", (msg) => { console.log("error", msg); prms.handleErrorCallback(msg) })
            .on("complete", (msg) => { console.log("complete sync", msg) })

    }

    public disconnectDb = () => {
        try {
            this.dbRemote.close();
            this.dbLocal.close();
            this.setStatusConnexao("off");
            this.setDbConnected("local");
            return { status: "ok", mensagem: "Desconectado com sucesso!" };
        } catch (error) {
            console.log("error disconnectDb", error);
            return { status: "error", mensagem: "Erro ao desconectar o banco de dados: " + error };
        }
    }

    public addAnexoDoc = async (row:any,anexo:Blob,anexo_id?:string) => {
        try {
            if(!row._id){
                return {status:'error',msg:"O documento informado precisa ter o campo _id."}
            }
            let id = row._id;
            let rev =row._rev;
            let name = ""
            //pegar a extensao do arquivo
            let ext = anexo.type.split("/")[1];
            if(!anexo_id)//se nao tiver anexo_id é para adicionar
                name = `${getNewId()}.${ext}`;
            else//se nao, é para alterar
                name = anexo_id;
            let mime = anexo.type;
            let resp = await this.dbLocal.putAttachment(id,name,rev,anexo,mime)
            if(resp.ok){
                return {status:"ok",id:name,data:resp}
            } else {
                return {status:"error",msg:"Não salvou a imagem"};
            }
        } catch (error) {
            return {status:'error',msg:'error ao anexar '+error}
        }
    }

    public getAnexoDoc = async(doc_id:string,anexo_id:string)=>{
        try {
            let resp = await this.dbLocal.getAttachment(doc_id,anexo_id);
            let file = URL.createObjectURL(resp as Blob);
            return {status:"ok", data:file}
        } catch (error) {
            return {status:'error',msg:'erro buscar o anexo '+error}
        }
    }

    public removerAnexoDoc = async(doc_id:any,anexo_id:string,rev:string)=>{
        try {
            let resp = await this.dbLocal.removeAttachment(doc_id,anexo_id,rev);
            if(resp.ok){
                return {status:"ok",data:resp.rev}
            } else {
                return {status:"error",msg:"Anexo não foi removido."}
            }
        } catch (error) {
            return {status:'error',msg:'erro ao remover anexo '+error}
        }
    }

}

export const db = new Db()
